/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { isRentalMandate } from '../../lib/common/mandate.mjs'

export function useAgencyFeesLabel (type: MandateType, percentage?: number): string {
  const intl = useIntl()

  const values = {
    percentage: percentage != null
      ? intl.formatNumber(percentage, { maximumFractionDigits: 4 })
      : '?'
  }

  if (isRentalMandate({ type })) {
    return intl.formatMessage({
      id: 'rental_fees',
      defaultMessage: 'Honoraires de location ({percentage}%)'
    }, values)
  }
  return intl.formatMessage({
    id: 'agency_fees',
    defaultMessage: 'Frais d\'agence ({percentage}%)'
  }, values)
}
